import axios from "axios";

const baseApi = axios.create({
  baseURL: "/api",
});

baseApi.interceptors.request.use(
  (config) => {
    const storageData = localStorage.getItem("authUser");

    if (storageData) {
      const parsedData = JSON.parse(storageData);
      const token = parsedData?.token;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default baseApi;
